import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModuleTestService } from 'src/app/pages/virtual-class/children/services/module-test.service';
import {
  Question,
  Response,
  TestDetail,
} from 'src/app/pages/virtual-class/interfaces';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-test-detail',
  templateUrl: './test-detail.component.html',
  styleUrls: ['./test-detail.component.scss'],
})
export class TestDetailComponent implements OnInit, OnDestroy {
  public testDetail: TestDetail;
  private _emitTestObs: Subscription;

  constructor(
    private moduleTestSv: ModuleTestService,
    private httpSv: HttpService
  ) {}

  ngOnInit() {
    this._emitTestObs = this.moduleTestSv.emitTestId$.subscribe(async (id) => {
      const res = await this.httpSv.itemIndex(
        'learning',
        '',
        { id },
        'responsesShow'
      );
      const test: TestDetail = res.data;
      console.log('test :>> ', test);
      test.questions.forEach((item) => {
        if (item.type === 'selectionMultiple' && item.response) {
          const obj: Response[] = [];

          item.response.answer = item.response.answer.replace('[', '');
          item.response.answer = item.response.answer.replace(']', '');
          item.response.correct = item.response.correct.replace('[', '');
          item.response.correct = item.response.correct.replace(']', '');

          const answers: any[] = item.response.answer.split(',');
          const corrects: any[] = item.response.correct.split(',');
          const responses: string[] = item.response.answerResponse.split(',');

          answers.forEach((value, index) => {
            obj.push({
              answer: value,
              answerResponse: responses[index],
              correct: corrects[index],
              correctId: '',
            });
          });

          item.response.multipleAnswer = obj;
        }
      });

      this.testDetail = res.data;
      console.log('res :>> ', res);
    });
  }

  async changeValueResponse(event: Event, question: Question) {
    const ev = event.target as HTMLIonToggleElement;
    question.response.correct = ev.checked ? '1' : '0';
    const res = await this.httpSv.itemAction(
      question.response,
      'learning',
      'responseUpdate'
    );
    console.log('res :>> ', res);
  }

  ngOnDestroy(): void {
    this._emitTestObs.unsubscribe();
  }
}
